export default __webpack_public_path__ + "static/media/icon_chat_white.cbd96597.svg";